import { useUserUUID } from "@annunciate/core";
import { useQuery } from "./base";
import { BOOKMARK_GET } from "../queries/bookmark";
export const useBookmarksQuery = (contentId) => {
    const uuid = useUserUUID(true);
    return useQuery(["bookmark", uuid], BOOKMARK_GET, { contentId }, undefined, (data) => data.bookmarks);
};
//# sourceMappingURL=useBookmarksQuery.js.map